// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button, Container } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    ReceiptLineFormFields,
    showReceiptLineFields,
    receiptTypes
} from "./Receipt.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";

import { TableRow, TableCell } from "@mui/material";
import GoInlineField from "../../../components/Inputs/GoInlineField";

const ReceiptLine = ({ values, touched, errors, handleChange, id, receiptHeaderId, feeType, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [receipt_line, setReceiptLine] = useState(receiptTypes[feeType].state);
    const [formFields, setFormFields] = useState(receiptTypes[feeType].formFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "autocomplete")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getAccounts = async () => {
        spinService.on();
        const response = await get(EntityConstants.ACCOUNTS, "max=all");
        const data = await response.json();
        attachOptions("credit_ledger_id", data);
        spinService.off();
    };

    const handleValueChange = (e, values) => {
        if (e.target.name === "credit_amount") {
            const vat_percentage = feeType === "Other Fees" ? 5 : 0;
            let vat_amount = (e.target.value / 100) * vat_percentage;
            values.vat_amount = vat_amount;
            values.total_amount = Number(e.target.value) + Number(vat_amount);
        };
        if (e.target.name === "vat_percentage") {
            let vat_amount = (values.credit_amount / 100) * e.target.value;
            values.vat_amount = vat_amount;
            values.total_amount = Number(values.credit_amount) + Number(vat_amount);
        };
    };

    const getModeOfPayes = async () => {
        spinService.on();
        const response = await get(EntityConstants.MODE_OF_PAYES, `max=all`);
        const data = await response.json();
        attachOptions("mode_of_pay_id", data);
        spinService.off();
    };

    const getBankDetails = async () => {
        spinService.on();
        const response = await get(EntityConstants.BANK_DETAILS, `max=all`);
        const data = await response.json();
        attachOptions("bank_detail_id", data);
        spinService.off();
    };


    useEffect(() => {
        getAccounts();
        if (feeType === "Account & Finance" || feeType === "PDC Bank Receipt") {
            getModeOfPayes();
            getBankDetails();
        };
    }, [id]);

    return (

        <TableRow
            hover
            key={"action_row"}
            tabIndex={-1}
            role="checkbox"
        >
            {formFields.map((formField, index) => {
                return (
                    <TableCell
                        colSpan={formField.colSpan === undefined ? 1 : formField.colSpan}
                        key={"col" + index}
                    // align={col.align}
                    >
                        <GoInlineField
                            config={formField}
                            values={values}
                            touched={touched}
                            errors={errors}
                            handleChange={(e) => { handleChange(e); handleValueChange(e, values); }}
                            onClose={() => onClose()}
                        />
                    </TableCell>
                );
            })}
        </TableRow>
    );
};

ReceiptLine.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default ReceiptLine;
